import React from "react";
import Airtime from "../../Component/Products/airtime";

const MainAirtime = () => {
	return <Airtime />;
};

export default MainAirtime;
